var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"maxlength":_vm.maxLength,"type":_vm.type,"disabled":_vm.disabled,"value":_vm.model},on:{"input":_vm.handleInputValue,"blur":_vm.checkInputValue}})}
var staticRenderFns = []

export { render, staticRenderFns }